const TRANSFER_API_URL = `${process.env.REACT_APP_BACKEND_URL}synctrack/transfer`;

export const handleBcItemToFusionProductFlow = async (syncFlow, masterConnectors) => {
    try {
        const token = localStorage.getItem('token');
        const flowId = syncFlow.instanceId;
        if (!flowId) throw new Error('Instance ID is required to run this flow.');

        // Prepare request URL
        const url = `${TRANSFER_API_URL}/bcitem-fusionproduct?flowId=${flowId}`;

        // Make API request 
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorText = await response.text();
            let errorMessage = `API Error: ${response.statusText}`;
            try {
                const errorObj = JSON.parse(errorText);
                if (errorObj.message) errorMessage = errorObj.message;
            } catch (e) {
                if (errorText) errorMessage = errorText;
            }
            throw new Error(errorMessage);
        }

        // Handle 204 No Content (Success but no data)
        if (response.status === 204) {
            return { status: 'success', message: 'Sync completed. No records found to process.' };
        }

        const data = await response.json();
        return data;

    } catch (error) {
        console.error('Error in BC Item to Fusion Product transfer:', error);
        throw error;
    }
};
